export default __webpack_public_path__ + "static/3-31-0-0-e2fd7d69bcb37572cc489d4a7903dd45.jpg";